import axios from 'axios';

import { IAffRespKiosque } from '@/shared/model/aff-resp-kiosque.model';

const baseApiUrl = 'api/aff-resp-kiosques';

export default class AffRespKiosqueService {
  public find(id: number): Promise<IAffRespKiosque> {
    return new Promise<IAffRespKiosque>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IAffRespKiosque): Promise<IAffRespKiosque> {
    return new Promise<IAffRespKiosque>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IAffRespKiosque): Promise<IAffRespKiosque> {
    return new Promise<IAffRespKiosque>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
